module.exports = __webpack_public_path__ + "static/img/business_chair_h2_r.63c2275.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/simple/business_chair_h2_r.png
// module id = Pb3w
// module chunks = 3